import { SegmentedControl } from './SegmentedControl';

export type * from './SegmentedControl.types';
export { SegmentedControl };

export default SegmentedControl;
